import Vue from 'vue';
import {ValidationObserver, ValidationProvider, extend, localize} from 'vee-validate';
import {required , min} from 'vee-validate/dist/rules';
import fa from 'vee-validate/dist/locale/fa.json';

extend('required', required);
extend('min', min);

localize({
    fa: {
        messages: fa.messages,
        names:{
            mobile:'شماره موبایل'
        }
    }
});
localize({
    fa,
});
localize('fa' , fa);
// Object.keys(rules).forEach(rule => {
//     extend(rule, rules[rule]);
// });

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);